import React from "react";
import { Summary as SummaryView } from "./views";

export const Summary: React.FC = () => {
  return (
    <React.Fragment>
      <SummaryView />
    </React.Fragment>
  );
};
